import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '@univacity/angular/datas';
import {
  AngularUiModule,
  CustomValidators,
  DestroyAbleComponent,
  FormUtil,
} from '@univacity/angular/ui';
import { ApiError, RoutePath } from '@univacity/shared/types';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'un-forgot-password-form',
  imports: [ReactiveFormsModule, RouterModule, AngularUiModule],
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordFormComponent
  extends DestroyAbleComponent
  implements OnInit
{
  @Input() returnUrl?: string;
  form: FormGroup;
  loginLink?: string | string[] = [];

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private message: NzMessageService,
    @Optional() public modalRef?: NzModalRef,
    @Optional()
    @Inject(NZ_MODAL_DATA)
    private nzModalData?: {
      returnUrl?: string;
    }
  ) {
    super();
  }

  ngOnInit(): void {
    this.returnUrl ??=
      this.nzModalData?.returnUrl ||
      this.route.snapshot.queryParams['returnUrl'];
    if (!this.modalRef) {
      this.loginLink = RoutePath.authLogin;
    }

    if (this.auth.isLoggedIn) {
      if (this.modalRef) this.modalRef.close();
      else this.router.navigate([this.returnUrl || '/']);
    }
    this.initForm();
  }

  initForm() {
    const { email } = this.route.snapshot.queryParams;
    this.form = this.fb.group({
      email: [email, [Validators.required, CustomValidators.email]],
      returnUrl: [this.returnUrl],
    });
  }

  submit() {
    FormUtil.updateFormValidity(this.form);

    if (this.form.valid) {
      this.auth
        .forgotPassword(this.form.value)
        .pipe(takeUntil(this.dead$))
        .subscribe({
          next: () => {
            this.message.success(
              $localize`Your password have reseted. Please check your email for instructions.`,
              { nzDuration: 100000 }
            );
            if (this.modalRef) this.modalRef?.close();
            else this.router.navigate([this.returnUrl || '/']);
          },
          error: (err?: ApiError) =>
            err?.message && this.message.error(err.message),
        });
    }
  }
}
